"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredMessage = exports.centeredStyle = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const VizPortalStyles_1 = require("./style/VizPortalStyles");
exports.centeredStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
const CenteredMessageContainer = (0, vizportalclient_common_components_1.divWithStyle)('CenteredMessageContainer', Object.assign(Object.assign(Object.assign({}, VizPortalStyles_1.vizPortalFontStyle), exports.centeredStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge, color: widgets_1.TabStyles.Colors.L8, textAlign: 'center' }));
function CenteredMessage(props) {
    return (react_1.default.createElement(CenteredMessageContainer, null, props.message));
}
exports.CenteredMessage = CenteredMessage;
//# sourceMappingURL=CenteredMessage.js.map